import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/plans/PageContent.tsx");
